import { useState, useEffect } from 'react';
import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import useNavigation from '@Navigation/useNavigation';
import { useDeps } from '@Contexts/DI';
import Link from '@UI/Link';
import { IconDivan, IconMatras } from './icons';
import styles from './ChoosifyButton.module.css';

import type { LinkProps as UILinkProps } from '@divlab/divanui';
import type { FC } from 'react';

interface ChoosifyButtonProps extends Omit<UILinkProps, 'view'> {
  view?: 'divan' | 'matras';
  isAlwaysShow?: boolean;
  label?: string;
}

const ChoosifyButton: FC<ChoosifyButtonProps> = (props) => {
  const { view = 'divan', isAlwaysShow, label, className, ...restProps } = props;
  const { t } = useTranslation();
  const { analytics } = useDeps();
  const [choosifyGroup, setChoosifyGroup] = useState('');
  const { pathname } = useNavigation();
  const isDivan = view === 'divan';
  const isChoosifyActive = isAlwaysShow || choosifyGroup === 'A';
  const buttonId = `choosify-${view}`;

  useEffect(() => {
    const abTestUrlList = [
      '/category/divany-i-kresla',
      '/category/divany',
      '/category/pramye-divany',
      '/category/uglovye-divany',
      '/category/modulnye-divany',
      '/category/kushetki',
      '/category/divany-dlya-sna',
      '/category/malenkie-divany',
      '/category/divany-dizajnerskie',
      '/category/divany-krovati',
      '/category/detskiee-divany',
      '/category/ortopedicheskie-divany-dlya-sna',
      '/category/ofisnye-divany',
      '/category/rasprodazha-divanov',
    ];

    if (!abTestUrlList.some((url) => pathname.includes(url))) {
      setChoosifyGroup('');

      return;
    }

    const saved = localStorage.getItem('_CS_Group');

    if (saved) {
      setChoosifyGroup(saved);
    }
  }, [pathname, setChoosifyGroup]);

  const handleClick = () => {
    if (!isDivan) return;

    analytics.dispatchEvent('filters.choosifyButton.click', {
      label: label || buttonId,
    });
  };

  return (
    <Link
      {...restProps}
      className={cn(styles.main, { [styles.active]: isChoosifyActive }, className)}
      id={buttonId}
      to={isDivan ? '/quiz/divany' : '/promo/mattrasses'}
      onClick={handleClick}
      view='primary'
    >
      <div className={styles.content}>
        <span className={styles.text}>{t(`ui.choosify.${view}`)}</span>
        {isDivan ? <IconDivan /> : <IconMatras />}
      </div>
    </Link>
  );
};

export default ChoosifyButton;
